import React, { useContext, useEffect, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import InfiniteScroll from 'react-infinite-scroller';

import { Container, Loader } from 'semantic-ui-react';

import '../css/NotificationsView.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { NOTIFICATION_NAV_TYPE } from '../constants';

import { VIEW_SELECTION } from '../managers/NavigationManager';

const NotificationsView = observer((props) => {
  const { t } = props;

  const { navigationManager, notificationManager, userManager } = useContext(MobXProviderContext);

  const [isRefreshingNotifications, setIsRefreshingNotifications] = useState(false);

  const ButtonBar = SatCoreComponent('ButtonBar');
  const DefaultNotificationCard = SatCoreComponent('DefaultNotificationCard');
  const SatCoreLoader = SatCoreComponent('SatCoreLoader');
  const SystemNotificationCard = SatCoreComponent('SystemNotificationCard');
  const ZeroStateCard = SatCoreComponent('ZeroStateCard');

  useEffect(() => {
    (async () => {
      navigationManager.setView(VIEW_SELECTION.NOTIFICATIONS);
      // TODO remove
      // TODO notifications are now fetched whenever TopNav active tab changes (per DEMO-2504)
      // TODO so we no longer need to call it here
      // await handleFetchNotifications();
    })();
  }, []);

  const handleClickNotificationBarButton = async (_event, buttonBarObj = {}) => {
    const notificationsType = buttonBarObj?.buttonKey || NOTIFICATION_NAV_TYPE.MANUAL;
    notificationManager.setActiveNotificationType(notificationsType);
    await handleFetchNotifications();
  };

  const handleFetchNotifications = async (page) => {
    if (!isRefreshingNotifications && !page) {
      setIsRefreshingNotifications(true);
    }
    if (notificationManager.activeNotificationType === NOTIFICATION_NAV_TYPE.SYSTEM) {
      await notificationManager.fetchSystemNotifications({
        page,
        userId: userManager.userId
      });
      if (!page) {
        setIsRefreshingNotifications(false);
      }
    } else {
      await notificationManager.fetchManualNotifications({
        page,
        userId: userManager.userId
      });
      if (!page) {
        setIsRefreshingNotifications(false);
      }
    }
  };

  const handleDeleteSystemNotification = async (notification) => {
    if (isRefreshingNotifications) {
      return;
    }
    setIsRefreshingNotifications(true);
    await notificationManager.deleteNotification(notification.id);
    await handleFetchNotifications();
    setIsRefreshingNotifications(false);
  };

  const renderNotificationButtonBar = () => {
    return (
      <Container className='notifications-button-bar-container'>
        <ButtonBar
          buttonBarObjs={[
            {
              buttonKey: NOTIFICATION_NAV_TYPE.MANUAL,
              defaultActive: notificationManager.activeNotificationType === NOTIFICATION_NAV_TYPE.MANUAL,
              doNotTranslate: true,
              translatedButtonKey: t(NOTIFICATION_NAV_TYPE.MANUAL, { count: notificationManager.manualNotificationCount }),
            },
            {
              buttonKey: NOTIFICATION_NAV_TYPE.SYSTEM,
              defaultActive: notificationManager.activeNotificationType === NOTIFICATION_NAV_TYPE.SYSTEM,
              doNotTranslate: true,
              translatedButtonKey: t(NOTIFICATION_NAV_TYPE.SYSTEM, { count: notificationManager.systemNotificationCount }),
            }
          ]}
          onClickBarButton={handleClickNotificationBarButton}
        />
      </Container>
    );
  };

  const renderNotificationCards = () => {
    if (notificationManager.activeNotificationType === NOTIFICATION_NAV_TYPE.SYSTEM) {
      if (notificationManager.systemNotificationMessages?.length) {
        return notificationManager.systemNotificationMessages?.map?.((notification, _index) => {
          return (
            <SystemNotificationCard
              key={notification.id}
              handleDeleteSystemNotification={handleDeleteSystemNotification}
              notification={notification}
              showDelete={true} />
          );
        });
      } else if (notificationManager.loaded) {
        return (
          <ZeroStateCard translationKey='noSystemNotificationsToDisplay' />
        );
      }
    } else {
      if (notificationManager.manualNotificationMessages?.length) {
        return notificationManager.manualNotificationMessages?.map?.((notification, _index) => {
          return (
            <DefaultNotificationCard
              key={notification.id}
              notification={notification} />
          );
        });
      } else if (notificationManager.loaded) {
        return (
          <ZeroStateCard translationKey='noManualNotificationsToDisplay' />
        );
      }
    }
  };

  let hasMoreNotifications;
  if (notificationManager.activeNotificationType === NOTIFICATION_NAV_TYPE.SYSTEM) {
    hasMoreNotifications = notificationManager.hasMoreSystemNotifications;
  } else {
    hasMoreNotifications = notificationManager.hasMoreManualNotifications;
  }

  return (
    <div className='notifications-view'>
      <Container className='notifications-view-header'>
        <div className='notifications-view-header-title'>
          {t('notificationsHeaderLabel')}
        </div>
      </Container>

      {renderNotificationButtonBar()}

      {/* NOTE: checking for `notificationManager.loaded` when rendering InfiniteScroll will
      cause the scroll position to be lost. That is why we are currently commenting it out here. */}

      <Container className='notification-cards-container'>
        {(userManager.loaded /* && notificationManager.loaded */ && !isRefreshingNotifications) ? (
          <InfiniteScroll
            className='ui items scroller'
            hasMore={hasMoreNotifications}
            initialLoad={false}
            loadMore={handleFetchNotifications}
            loader={<Loader key={0} active inline />}
            pageStart={0}
            useWindow={true}>
            {renderNotificationCards()}
          </InfiniteScroll>
        ) : (
          <SatCoreLoader height='70vh' />
        )}
      </Container>
    </div>
  );
});
export default NotificationsView;

SatCoreRegister('NotificationsView', NotificationsView);
